import script from "./AddEditBaseIngredients.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditBaseIngredients.vue?vue&type=script&setup=true&lang=js"

import "./AddEditBaseIngredients.vue?vue&type=style&index=0&id=78a34fc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a34fc8"]])

export default __exports__